export const locales = {
  en: require('./en')
};
const messages = {
  memberInfo: {
    name: '姓名',
    accout: '账号',
    cellphone: '手机',
    email: '邮箱'
  },
  edit: '编辑',
  appresponsiberInfo: {
    title: '应用责任人',
    tip: '该角色具有应用创建、开发、应用管理及角色管理的最大权限；最多可添加5人。'
  },
  collaborativeDevInof: {
    title: '协同开发者',
    tip: '支持下载开发模板、开发应用并提交开发版；最多可添加50人。'
  }
};

export default {locales, ...messages};
